(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venom-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-v-hero-play]');
    if (!button) return;
    var media = button.closest('.v-hero__media');
    var frame = document.createElement('iframe');
    frame.src = button.dataset.src;
    frame.title = button.dataset.title;
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.className = 'v-hero__frame';
    media.appendChild(frame);
    media.classList.add('is-playing');
    button.remove();
    frame.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venom-lead-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TOPICS = ['ai', 'servers', 'gaming', 'rendering', 'services'];
    function init() {
      var topic = (new URLSearchParams(location.search).get('topic') || '').toLowerCase();
      var forms = document.querySelectorAll('.v-lead__form');
      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];
        if (form.dataset.vLead) continue;
        form.dataset.vLead = '1';
        if (TOPICS.indexOf(topic) > -1) {
          form.elements['contact[topic]'].value = topic;
          form.elements['contact[topic_prefill]'].value = topic;
        }
        form.addEventListener('submit', onSubmit);
      }
    }
    function onSubmit(event) {
      var form = event.currentTarget;
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          event: 'quote_submit',
          topic: form.elements['contact[topic]'].value,
          gpu_count: form.elements['contact[gpu_count]'].value
        });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venom-node-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(root) {
      if (root.dataset.vNodes) return;
      root.dataset.vNodes = '1';
      var chips = root.querySelectorAll('.v-nodes__chip');
      var cards = root.querySelectorAll('.v-nodes__card');
      root.addEventListener('click', function (event) {
        var chip = event.target.closest('.v-nodes__chip');
        if (!chip) return;
        var value = chip.getAttribute('aria-pressed') === 'true' ? '' : chip.getAttribute('data-software');
        for (var i = 0; i < chips.length; i++) {
          chips[i].setAttribute('aria-pressed', value && chips[i] === chip ? 'true' : 'false');
        }
        for (var j = 0; j < cards.length; j++) {
          var list = (cards[j].getAttribute('data-software') || '').split('|');
          cards[j].classList.toggle('is-dim', value !== '' && list.indexOf(value) === -1);
        }
      });
    }
    function init() {
      var roots = document.querySelectorAll('.v-nodes');
      if (!roots.length) return;
      for (var i = 0; i < roots.length; i++) bind(roots[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
